import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './services/authContext';
import ErrorBoundary from './components/ErrorBoundary';

import Login from './pages/Login';
import NewUser from './pages/NewUser';
import Header from './components/Header';
import Dashboard from './pages/Dashboard';
import Pilares from './pages/Pilares';
import Profile from './pages/Profile';
import Footer from './components/Footer';
import VerifyUser from './pages/VerifyUser';

function AppContent() {
  return (
    <Routes>
      {/* Redirecionar para /login por padrão */}
      <Route path="/" element={<Login />} />
      {/* Página de Login não tem Header nem Footer */}
      <Route path="/login" element={<Login />} />

      {/* Páginas que terão o Header e o Footer */}
      <Route
        path="/dashboard"
        element={
          <>
            <Header />
            <Dashboard />
            <Footer />
          </>
        }
      />
      <Route
        path="/pilares"
        element={
          <>
            <Header />
            <Pilares />
            <Footer />
          </>
        }
      />
      <Route
        path="/profile"
        element={
          <>
            <Header />
            <Profile />
            <Footer />
          </>
        }
      />

      {/* Outras páginas, como NewUser, também podem ser adicionadas sem Header e Footer */}
      <Route path="/newuser" element={<NewUser />} />
      <Route path="/verify/:token" element={<VerifyUser />} />
    </Routes>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <Router>
          <AppContent />
        </Router>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
